// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddDetails_importCsvCard__G353G","addBtnContainer":"AddDetails_addBtnContainer__mswKG"};